// NOTE! For the first iteration, we are simply copying the implementation of Assignees
// It will soon be overhauled in Issue https://gitlab.com/gitlab-org/gitlab/-/issues/233736
import { GlAvatar, GlIcon } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ReviewerAvatar',
    components: {
        GlAvatar,
        GlIcon
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        imgSize: {
            type: Number,
            required: true
        }
    },
    computed: {
        avatarUrl () {
            return this.user.avatarUrl || this.user.avatar_url || gon.default_avatar_url;
        },
        hasMergeIcon () {
            return this.user.mergeRequestInteraction && !this.user.mergeRequestInteraction.canMerge;
        }
    }
};
